import type { Map as MapLibreMap } from 'maplibre-gl';

/**
 * Whether the map has been removed. Leaving the map view unmounts the map before the zone panel, so the
 * panel's cleanup (terra-draw, the radius preview) runs against a map whose style and sources are gone.
 * MapLibre fires 'remove' synchronously at the end of `remove()`, so this knows in time.
 */
export function trackMapRemoval(map: MapLibreMap) {
  let isRemoved = false;
  const onRemove = () => {
    isRemoved = true;
  };
  map.once('remove', onRemove);
  return {
    isRemoved: () => isRemoved,
    /** Stops listening; call it in a cleanup that runs while the map is still there. */
    dispose: () => map.off('remove', onRemove),
  };
}
